"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CardLocationModel {
    constructor(indexCard, indexLine, initialDataLocationsModels, elementsForLine) {
        this.indexCard = indexCard;
        this.indexLine = indexLine;
        this.initialDataLocationsModels = initialDataLocationsModels;
        this.elementsForLine = elementsForLine;
    }
    calculateProgressPercent(total, assigned) {
        return (assigned / total) * 100;
    }
    isEqualValues(valueOne, valueTwo) {
        if (valueOne === valueTwo)
            return true;
        return false;
    }
    get collectPercent() {
        if (this.collectSamplesAssignedForTime > this.collectTotalSamplesForTime) {
            return 100;
        }
        else {
            return this.calculateProgressPercent(this.collectTotalSamplesForTime, this.collectSamplesAssignedForTime);
        }
    }
    get collectProgressCurrentTime() {
        if (this.collectSamplesAssignedForTime > this.collectTotalSamplesForTime) {
            return 100;
        }
        else {
            return this.calculateProgressPercent(this.collectTotalSamplesForTime, this.collectSamplesAssignedForTime);
        }
    }
    get collectCurrentTime() {
        const times = this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine].time_details;
        let allTimesIncompleted = true;
        let currentTime = 0;
        for (const time of times) {
            if (time.samplesAssigned > 0) {
                allTimesIncompleted = false;
                break;
            }
            if (time.samplesAssigned !== this.collectTotalSamplesForTime) {
                currentTime = time.time;
            }
        }
        if (allTimesIncompleted) {
            currentTime = times[0].time;
        }
        return currentTime;
    }
    get collectTotalSamplesForTime() {
        return this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine].samplesTotalThisTime;
    }
    get collectSamplesAssignedForTime() {
        return this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine].time_details[0].samplesAssigned;
    }
    get collectLocationId() {
        return this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine].id;
    }
    get collectName() {
        return this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine].name;
    }
    get collectLocationObject() {
        return this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine];
    }
    get collectAccent() {
        let allTimesCompleted = true;
        const times = this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine].time_details;
        for (const time of times) {
            if (time.samplesAssigned < this.collectTotalSamplesForTime) {
                allTimesCompleted = false;
            }
        }
        if (this.isEqualValues(this.collectSamplesAssignedForTime, this.collectTotalSamplesForTime) &&
            this.collectSamplesAssignedForTime > 0) {
            return 'info';
        }
        else if (allTimesCompleted) {
            return 'success';
        }
        else {
            return 'primary';
        }
    }
    get collectTitleActionAssign() {
        let nextTime = 0;
        const times = this.initialDataLocationsModels[this.indexCard + this.elementsForLine * this.indexLine].time_details;
        for (const time of times) {
            if (time.samplesAssigned < this.collectTotalSamplesForTime &&
                time.samplesAssigned > 0) {
                nextTime = time.time;
            }
        }
        if (this.isEqualValues(this.collectSamplesAssignedForTime, this.collectTotalSamplesForTime)) {
            return `Start T${nextTime}`;
        }
        else {
            return `Assign T${this.collectCurrentTime}`;
        }
    }
}
exports.default = CardLocationModel;
